import HNSColors from "../../../../../../ui library/HNSColors";

export const STRINGS = {
  flagState: {
    1: {
      iconName: "his-check-circle",
      color: HNSColors.success[500],
      bgColor: HNSColors.success[700],
      borderColor: HNSColors.success[600],
    },
    2: {
      iconName: "his-alert-circle",
      color: HNSColors.failure[500],
      bgColor: HNSColors.failure[700],
      borderColor: HNSColors.failure[600],
    },
  },
};
